import { Autocomplete } from '@mantine/core'

import { STATE_AND_PROVINCE_ABBREVIATION_GROUPS } from 'src/lib/usStates'

interface ApplicationStateSelectProps {
  value: string
  error?: string
  required?: boolean
  onChange: (value: string) => void
  placeholder?: string
  label?: string
}

const ApplicationStateSelect = ({
  value,
  error,
  required = false,
  onChange,
  placeholder = 'State',
  label,
}: ApplicationStateSelectProps) => {
  const isMobile = window.innerWidth < 768
  const labelStyles = 'text-sm text-doubleNickel-gray-600 font-medium'
  const wrapperStyles = 'border-b-[1px] border-doubleNickel-gray-300'
  const inputStyles = `text-base font-medium`
  const rootStyles = `w-full`

  return (
    <Autocomplete
      variant={isMobile ? 'unstyled' : 'unstyled'}
      classNames={{
        label: labelStyles,
        wrapper: wrapperStyles,
        input: inputStyles,
      }}
      className={rootStyles}
      label={label}
      placeholder={placeholder}
      value={value || ''}
      onChange={onChange}
      data={STATE_AND_PROVINCE_ABBREVIATION_GROUPS}
      required={required}
      error={error}
    />
  )
}

export default ApplicationStateSelect
